module.exports = __webpack_public_path__ + "static/media/fruits_item_list.7edd57f3.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/fruits/fruits_item_list.csv
// module id = 726
// module chunks = 0